import React, { Component } from 'react'
import './index.css'

export default class Button extends Component {
    render() {
        return (
            <div onClick={this.props.onClick}>
                <p className={this.props.colored ? 'rd-colored-big-button' : 'rd-big-button'} > {this.props.text}  </p>
            </div>
        )
    }
}
